import * as Yup from 'yup';

export const userEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Muito curto')
    .max(255, 'Limite máximo do tamanho do nome')
    .required('Campo obrigatório'),
  email: Yup.string().email('Email inválido').required('Campo obrigatório'),
  role: Yup.string()
    .oneOf(
      ['Administrador', 'Operador', 'Integração'],
      'O tipo precisa ser operador, administrador ou integração'
    )
    .required('Campo obrigatório'),
});
